import React from 'react';
import { Layout, Row, Col, Typography, Form, Input, Button, Card, Space } from 'antd';
import { 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined,
  SendOutlined 
} from '@ant-design/icons';
import './Contact.css';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const Contact: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log('Form values:', values);
    // Handle form submission here
  };

  return (
    <Layout className="contact-layout">
      <Content>
        <div className="contact-container">
          <div className="contact-header">
            <Title level={1}>Get Started With Byondcore SAAS</Title>
            <Paragraph className="contact-description">
              Byondcore is a complete accounts & finance admin dashboard for your business & fully equipped with various functionalities and is platform compatible
            </Paragraph>
          </div>

          <Row gutter={[48, 48]} className="contact-content">
            <Col xs={24} lg={12}>
              <Card className="contact-form-card">
                <Title level={3}>Send us a Message</Title>
                <Paragraph>
                  Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                </Paragraph>
                
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className="contact-form"
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[{ required: true, message: 'Please enter your first name' }]}
                      >
                        <Input placeholder="Enter your first name" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[{ required: true, message: 'Please enter your last name' }]}
                      >
                        <Input placeholder="Enter your last name" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: 'Please enter your email' },
                      { type: 'email', message: 'Please enter a valid email' }
                    ]}
                  >
                    <Input placeholder="Enter your email" />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    label="Phone Number"
                  >
                    <Input placeholder="Enter your phone number" />
                  </Form.Item>

                  <Form.Item
                    name="subject"
                    label="Subject"
                    rules={[{ required: true, message: 'Please enter a subject' }]}
                  >
                    <Input placeholder="Enter subject" />
                  </Form.Item>

                  <Form.Item
                    name="message"
                    label="Message"
                    rules={[{ required: true, message: 'Please enter your message' }]}
                  >
                    <TextArea 
                      rows={6} 
                      placeholder="Enter your message"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      size="large" 
                      htmlType="submit"
                      icon={<SendOutlined />}
                      block
                    >
                      Send Message
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>

            <Col xs={24} lg={12}>
              <div className="contact-info">
                <Title level={3}>Contact Information</Title>
                <Paragraph>
                  Get in touch with us for any questions about our services or to schedule a demo.
                </Paragraph>

                <Space direction="vertical" size="large" className="contact-details">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <MailOutlined />
                    </div>
                    <div className="contact-text">
                      <Text strong>Email</Text>
                      <Paragraph>info@byondcore.com</Paragraph>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <PhoneOutlined />
                    </div>
                    <div className="contact-text">
                      <Text strong>Phone</Text>
                      <Paragraph>+1 (555) 123-4567</Paragraph>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <EnvironmentOutlined />
                    </div>
                    <div className="contact-text">
                      <Text strong>Address</Text>
                      <Paragraph>
                        123 Business Street<br />
                        Suite 100<br />
                        New York, NY 10001
                      </Paragraph>
                    </div>
                  </div>
                </Space>

                <div className="demo-section">
                  <Title level={4}>Request a Demo</Title>
                  <Paragraph>
                    See Byondcore in action with a personalized demo tailored to your business needs.
                  </Paragraph>
                  <Button type="primary" size="large">
                    Click Here for Demo
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default Contact; 